import { ArrayField, ChipField, Datagrid, EditButton, List, ShowButton, SingleFieldList, TextField, useRecordContext } from "react-admin";
import { Chip } from "@mui/material"



export function MomentList() {
    return (
        <List >
            <Datagrid >
                <TextField source="name" />
                <TagsView source="tags" />
                <EditButton />
                <ShowButton />
            </Datagrid>
        </List>
    )
}


const colors = ['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']


export function TagsView() {
    const data = useRecordContext();
    if (!data || !data.tags || data.tags.length === 0) {
        return <></>
    }

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>{
            data.tags.map((tag) => <Chip key={tag} label={tag} color={colors[Math.floor(Math.random() * colors.length)]} />)
        }
        </div>
    )

}


